import { render } from "./DangCardBack.vue?vue&type=template&id=72504c0a&scoped=true"
import script from "./DangCardBack.vue?vue&type=script&lang=js"
export * from "./DangCardBack.vue?vue&type=script&lang=js"

import "./DangCardBack.vue?vue&type=style&index=0&id=72504c0a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72504c0a"]])

export default __exports__